import React, { useEffect, useState } from "react";
import { GetAllAssignUserOfSingleClient } from "../../../../redux/auth/authTypes";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { CircularAvatar } from "../../../commons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  allAssignUserOfSingleClient:
    | GetAllAssignUserOfSingleClient
    | null
    | undefined;
  tableHeader: [] | TableHeadersType[];
  assignedUsers: number[];
  setAssignedUsers: React.Dispatch<React.SetStateAction<any>>;
  setIsHeaderChecked: React.Dispatch<React.SetStateAction<boolean>>;
};
const AssignedUsersTableData = ({
  allAssignUserOfSingleClient,
  tableHeader,
  assignedUsers,
  setAssignedUsers,
  setIsHeaderChecked,
}: AppProps) => {
  useEffect(() => {
    if (
      allAssignUserOfSingleClient &&
      assignedUsers?.length === allAssignUserOfSingleClient?.data?.length
    ) {
      setIsHeaderChecked(true);
    } else {
      setIsHeaderChecked(false);
    }
  }, [assignedUsers, allAssignUserOfSingleClient]);

  const internalUserStyle = () => {
    return {
      padding: "4px 12px",
      color: "#407EEE",
      background: "#E5EEFE",
      borderRadius: "16px",
      width: "40px",
    };
  };

  const externalUserStyle = () => {
    return {
      padding: "4px 12px",
      color: "#6E4DC9",
      background: "#EBE6FB",
      borderRadius: "16px",
      width: "40px",
    };
  };

  const handleUnAssigneUsers = (data: number, checked: boolean) => {
    if (checked) {
      if (assignedUsers?.includes(data)) {
      } else {
        setAssignedUsers([...assignedUsers, data]);
      }
    } else {
      if (assignedUsers?.includes(data)) {
        let finalallUser: number[] = assignedUsers.filter((el) => el !== data);
        setAssignedUsers([...finalallUser]);
        setIsHeaderChecked(false);
      }
    }
  };
  return (
    <>
      {allAssignUserOfSingleClient &&
        allAssignUserOfSingleClient?.data?.length > 0 &&
        allAssignUserOfSingleClient?.data?.map((data: any) => {
          return (
            <tr>
              <td style={{ minWidth: "20px", maxWidth: "20px" }}>
                <input
                  type="checkbox"
                  name="fordCheckBox"
                  style={{
                    width: "19px",
                    height: "19px",
                    backgroundColor: "red",
                  }}
                  className="checkbox"
                  checked={
                    assignedUsers?.length
                      ? assignedUsers?.includes(data?.user_id)
                      : false
                  }
                  onChange={(e: any) => {
                    handleUnAssigneUsers(data?.user_id, e?.target.checked);
                  }}
                />
              </td>

              {tableHeader &&
                tableHeader?.map((item: any) => {
                  if (item.value === "name") {
                    return (
                      <td style={{ whiteSpace: "nowrap", minWidth: "350px" }}>
                        <div
                          className="ml-2"
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          <CircularAvatar
                            name={`${data?.first_name} ${data?.last_name}`}
                            image={JSON.parse(data?.profile_pic)?.file_url}
                          />
                          <div>
                            {(data?.first_name + data?.last_name).length >
                            20 ? (
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 250 }}
                                overlay={
                                  <Tooltip id="button-view-filter-invoice">
                                    {data?.first_name + " " + data?.last_name}
                                  </Tooltip>
                                }
                              >
                                <span>
                                  {`${data?.first_name} ${data?.last_name}`?.slice(
                                    0,
                                    20
                                  ) +
                                    (data?.first_name &&
                                    data?.last_name &&
                                    `${data?.first_name} ${data?.last_name}`
                                      ?.length > 20
                                      ? "..."
                                      : "")}
                                </span>
                              </OverlayTrigger>
                            ) : (
                              <>{`${data?.first_name} ${data?.last_name} `}</>
                            )}
                          </div>
                        </div>
                      </td>
                    );
                  } else if (item.value === "user_type") {
                    return (
                      <td className="text-start" style={{ minWidth: "350px" }}>
                        <span
                          style={
                            data?.user_type === 1
                              ? internalUserStyle()
                              : externalUserStyle()
                          }
                        >
                          {data?.user_type === 1
                            ? "Internal User"
                            : "External User"}
                        </span>
                      </td>
                    );
                  } else if (item.value === "email") {
                    return (
                      <td style={{ minWidth: "350px" }}>{data[item.value]}</td>
                    );
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default AssignedUsersTableData;
